import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { SimpleIndexedDBService } from '../services/simple-indexeddb.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RolePermissionsService } from './rolepermissions-service/rolepermissions-service';
import { UserProfileService } from './user-profile';

@Injectable({
  providedIn: 'root'
})

export class UserData {
  _favorites: string[] = [];
  HAS_LOGGED_IN = 'hasLoggedIn';
  HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
  userProfile: any;

  constructor(
    private indexedDB: SimpleIndexedDBService,
    private rolePermissionsService: RolePermissionsService,
    private userProfileService: UserProfileService
  ) { }

  hasFavorite(sessionName: string): boolean {
    return (this._favorites.indexOf(sessionName) > -1);
  }

  addFavorite(sessionName: string): void {
    this._favorites.push(sessionName);
  }

  removeFavorite(sessionName: string): void {
    const index = this._favorites.indexOf(sessionName);
    if (index > -1) {
      this._favorites.splice(index, 1);
    }
  }

  login(username: string): Promise<any> {
    return this.indexedDB.setItem(this.HAS_LOGGED_IN, true).then(() => {
      this.setUsername(username);
      return window.dispatchEvent(new CustomEvent('user:login'));
    });
  }

  signup(username: string): Promise<any> {
    return this.indexedDB.setItem(this.HAS_LOGGED_IN, true).then(() => {
      this.setUsername(username);
      return window.dispatchEvent(new CustomEvent('user:signup'));
    });
  }

  logout(): Promise<any> {
    return this.indexedDB.removeItem(this.HAS_LOGGED_IN).then(() => {
      return this.indexedDB.removeItem('username');
    }).then(() => {
      return this.indexedDB.removeItem('userfromIdToken');
    }).then(() => {
      return this.indexedDB.removeItem('userSubject');
    }).then(() => {
      window.dispatchEvent(new CustomEvent('user:logout'));
    });
  }

  setUsername(username: string): Promise<any> {
    return this.indexedDB.setItem('username', username);
  }

  getUsername(): Promise<string> {
    return this.indexedDB.getItem('username').then((value) => {
      return value;
    });
  }

  getTokenProfile(): Promise<string> {
    return this.indexedDB.getItem('userfromIdToken');
  }

  getProfile(): Promise<any> {
    return this.indexedDB.getItem('userSubject');
  }

  isLoggedIn(): Promise<boolean> {
    return this.indexedDB.getItem(this.HAS_LOGGED_IN);
  }

  get profile(){    
    return this.userProfileService.getUserProfile();
  }

  hasRoles(roles: number[]): boolean {
    if(!this.userProfile || this.userProfile === undefined){
      this.userProfileService.profile$.subscribe(profile => {
        this.userProfile = profile;
      });
      return false;
    }

    if (!Array.isArray(roles)) {
      return false;
    }

    if (this.userProfile) {      
        if (roles.includes(this.userProfile.role)) 
        { 
          return true; 
        }
    }
    return false;
  }
  
}
